
import React, { useEffect, useState } from 'react';
import { adminData, adminpage1, userData, userpage2, userpage3, userpage4, userpage5, userpage6 } from './SideData';
import SubMenu from './SubMenu';
import '../Static/PHPStatic/Sidebar.css'; // Import the CSS file

const Sidebar = ({ sidebarr }) => {
  const userdata = JSON.parse(sessionStorage.getItem('user'));
  const pgArr = userdata?.subuser_info?.map(val => val.pageId);
  const [menu, setMenu] = useState([]);
  const uniquePageIds = Array.from(
    new Set(
      pgArr
        ?.flatMap(str => str.split(',')) // split each string by comma
        ?.map(id => id.trim())           // trim spaces
        ?.filter(Boolean)                // remove empty values
    )
  );

  // console.log(uniquePageIds);
  useEffect(() => {
    if (userdata?.role === '2') {
      const value = getMenus(uniquePageIds);
      setMenu(value);
    } else if (userdata?.role === '3') {


      const val2 = getAdminOnly(uniquePageIds);
      setMenu(val2);
    } else if (userdata?.role === '1') {
      setMenu(adminData)
    }
  }, []);

  // console.log(uniquePageIds);

  function getMenus(uniquePageIds) {
    if (!Array.isArray(uniquePageIds)) return null;

    const has1 = uniquePageIds.includes('1');
    if (has1) {
      return userData;
    }

    const mergedPages = [];

    uniquePageIds.forEach(id => {
      switch (id) {
        case '2':
          mergedPages.push(...userpage2);
          break;
        case '3':
          mergedPages.push(...userpage3);
          break;
        case '4':
          mergedPages.push(...userpage4);
          break;
        case '5':
          mergedPages.push(...userpage5);
          break;
        case '6':
          mergedPages.push(...userpage6);
          break;
        default:
          break;
      }
    });

    return mergedPages;
  }


  function getAdminOnly(uniquePageIds) {
    if (!Array.isArray(uniquePageIds)) return null;

    const has1 = uniquePageIds.includes('1');


    if (has1) {
      return adminpage1;
    }

    const mergedPages = [];

    uniquePageIds.forEach(id => {
      switch (id) {
        case '2':
          mergedPages.push(...userpage2);
          break;
        case '3':
          mergedPages.push(...userpage3);
          break;
        case '4':
          mergedPages.push(...userpage4);
          break;
        case '5':
          mergedPages.push(...userpage5);
          break;
        case '6':
          mergedPages.push(...userpage6);
          break;
        default:
          break;
      }
    });

    return mergedPages;
  }



  const dataArr = uniquePageIds?.length > 0 ? getMenus(uniquePageIds) : userData;
  // console.log(dataArr);
  return (
    <nav className={`sidebar-nav ${sidebarr ? 'open' : 'closed'}`}>
      {menu ?
        <div className="sidebar-wrap">
          {menu.map((item, index) => {
            return <SubMenu item={item} key={index} />;
          })}
        </div> :
        <div className="sidebar-wrap">
          {adminData.map((item, index) => {
            return <SubMenu item={item} key={index} />;
          })}
        </div>
      }
    </nav>
  );
};

export default React.memo(Sidebar);
